<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SearchAsYouTypeFilter
          filter="institutional_groups"
          :items="store.searchedInstituGroups"
          item-label="name"
          item-value="_id"
          :active-filters="selectedFilters.institutional_groups"
          :is-loading="store.isInstitutionalGroupsFilterLoading"
          @search="searchInstituGroups"
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetInstituGroupsFilter"
        >
          Organes
        </SearchAsYouTypeFilter>
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>

      <FollawedRadioButtons
        all-match-route="/organes"
        follawed-route="/organes/follawed"
      />
    </div>

    <div class="params-row">
      <TotalMatched :item-count="store.groupsCount" />

      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Organes par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import FollawedRadioButtons from "@/follaw-fr/components/reusable/atoms/FollawedRouterRadioButtons.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import { useInstituGroupsStore } from "@follaw-fr/stores/institutional-groups";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import SearchAsYouTypeFilter from "@follaw-fr/components/filter-menu/molecules/SearchAsYouTypeFilter.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const store = useInstituGroupsStore();
const { selectedFilters } = storeToRefs(store);

const fetchGroupsList = async () => {
  selectedFilters.value.from = 0;
  await store.fetchInstituGroupsList();
};

// All filters in wanted display order with their labels
const filtersNames = {
  institution: "Institution",
  group_type: "Type d'organe",
};

const activeFilters = computed(() => {
  let arr = [];
  // Put all selected options from all filters with said filter name in an array for the SelectedFilters component
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      arr = [...arr, { filter: key, item: filter }];
    });
  });
  return arr;
});

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      fetchGroupsList();
    },
  });

const showScrollTop = computed(() => selectedFilters.value.size > 20);

const resetAllFilters = () => {
  store.resetFilters();
  fetchGroupsList();
};

const addFilterItem = (event) => {
  const targetFilters = selectedFilters.value[event.filter] || [];

  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: [...targetFilters, event.item],
  };
  fetchGroupsList();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] || [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }
  fetchGroupsList();
};

function searchInstituGroups(searchText) {
  if (searchText.length > 0) {
    store.getInstitutionalGroupsFilters(searchText);
  } else {
    store.authors = [];
  }
}

const resetFilter = (event) => {
  delete selectedFilters.value[event];
  fetchGroupsList();
};

const resetInstituGroupsFilter = () => {
  store.searchedInstituGroups = [];
  delete selectedFilters.value.institutional_groups;
  fetchGroupsList();
};
</script>
